module.exports = __webpack_public_path__ + "static/media/frost-reduced-more-compressed.de443322.gif";